import { jsx as _jsx } from "react/jsx-runtime";
import './PixelStreamPanel.css';
export const PixelStreamPanel = ({ streamUrl }) => {
    if (!streamUrl) {
        return (_jsx("div", { className: "pixel-stream-panel standby", role: "status", children: _jsx("p", { children: "Avatar stream will appear when the GPU pixel-stream worker is live." }) }));
    }
    return (_jsx("div", { className: "pixel-stream-panel", role: "region", "aria-label": "Unreal avatar stream", children: _jsx("iframe", { title: "Virtual Banker Avatar", src: streamUrl, allow: "autoplay; fullscreen; microphone; camera", className: "pixel-stream-iframe" }) }));
};
